import { render, staticRenderFns } from "./AlertNumberCard.vue?vue&type=template&id=43af655d&scoped=true"
import script from "./AlertNumberCard.vue?vue&type=script&lang=js"
export * from "./AlertNumberCard.vue?vue&type=script&lang=js"
import style0 from "./AlertNumberCard.vue?vue&type=style&index=0&id=43af655d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43af655d",
  null
  
)

export default component.exports